import { FaMinus, FaPlus } from 'react-icons/fa'
import { colors } from '../../../style'
import {
    Question as QLine,
    IconContainer,
    QuestionContainer
} from './FaqElement'

const Question = (props) => {
    const { activeQuestionId, questionId  } = props

    function isActive() {
        return activeQuestionId === questionId
    }

    function expandIcon() {
        if (isActive()) {
            return (
                <FaMinus
                    size={20}
                    color={colors.green}
                />
            )
        }

        return (
            <FaPlus
                size={20}
                color={colors.black}
            />
        )
    }

    function answer() {
        if (!isActive()) {
            return
        }
        return props.children
    }

    function toggle() {
        const wasActive = isActive()
        props.setActiveQuestionId(wasActive ? undefined : questionId)
        const nextUrl = wasActive
            ? window.location.pathname
            : `${window.location.pathname}#${questionId}`
        window.history.replaceState(null, '', nextUrl)
    }

    return (
        <QuestionContainer id={questionId} onClick={toggle}>
            <IconContainer>
                { expandIcon() }
            </IconContainer>
            <QLine highlighted={isActive()}>
                { props.content }
            </QLine>
            { answer() }
        </QuestionContainer>
  )
}

export default Question
